import React, {useCallback, useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import "./image-file-upload.css"
import {MdOutlineAddPhotoAlternate} from "react-icons/md";
import {GrDocumentVideo} from "react-icons/gr";
import {IoClose, IoCloseCircleSharp} from "react-icons/io5";
import {TfiFiles} from "react-icons/tfi";
import getFileIcon from "../../../fxpilot/cloud-storage/utils/getFileIcon";
import {RiUploadCloudLine} from "react-icons/ri";

export const VideoFileUploadV2 = ({multiple = false, onChange}) => {
    const [files, setFiles] = useState([]);

    // Notify parent component of file changes
    useEffect(() => {
        onChange(files);
    }, [files]);

    // Handle file drops
    const onDrop = useCallback(
        (acceptedFiles) => {
            if (multiple) {
                setFiles((prevFiles) => [
                    ...prevFiles,
                    ...acceptedFiles.map((file) =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        })
                    ),
                ]);
            } else {
                setFiles(
                    acceptedFiles.map((file) =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        })
                    )
                );
            }
        },
        [multiple]
    );

    // Remove a file from the list
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Render preview for video files
    const renderPreview = (file) => {
        if (file.type.startsWith("video/")) {
            return (
                <video
                    src={file.preview}
                    alt={file.name}
                    controls
                />
            );
        } else {
            return <p>Unsupported file type</p>;
        }
    };

    // Dropzone setup
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: ["video/mp4", "video/avi", "video/mkv"], // Accept video files
        // multiple, // Whether to allow multiple files
    });

    return (
        <>
            {
                files.length > 0 ? '' :
                    <div style={{textAlign: 'center'}} {...getRootProps()} className="video-file-upload-container">
                        <input {...getInputProps()} />
                        <GrDocumentVideo size={60} color={"#3b987d"} stroke={"1.5"}/>
                        {isDragActive ? (
                            <p>Drop the Video here...</p>
                        ) : (
                            <p>
                                Drag and drop a Video, or <a href={"#"}>Browse</a> <br/>
                                <span>Max 100MB per video</span>
                            </p>
                        )}
                    </div>
            }

            {files.length > 0 && (
                <div style={{marginTop: "20px"}}>
                    <ul className="video-file-upload-container-ul">
                        {files.map((file, index) => (
                            <li
                                key={index}
                                className="video-file-container"
                            >
                                <div className="remove-image-btn" onClick={() => {
                                    setFiles([])
                                }}>
                                    <IoClose size={20} color={"#fff"}/>
                                </div>
                                {renderPreview(file)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};

export const VideoFileUploadV3 = ({prevFiles, multiple = false, onChange}) => {
    const [files, setFiles] = useState([]);

    // Notify parent component of file changes
    useEffect(() => {
        console.log('prevFile', prevFiles)
        if(prevFiles)
            setFiles(prevFiles)
    }, [prevFiles]);

    // Notify parent component of file changes
    useEffect(() => {
        onChange(files);
    }, [files]);

    // Handle file drops
    const onDrop = useCallback(
        (acceptedFiles) => {
            if (multiple) {
                setFiles((prevFiles) => [
                    ...prevFiles,
                    ...acceptedFiles.map((file) =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        })
                    ),
                ]);
            } else {
                setFiles(
                    acceptedFiles.map((file) =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        })
                    )
                );
            }
        },
        [multiple]
    );

    // Remove a file from the list
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Render preview for video files
    const renderPreview = (file) => {
        if (file.type.startsWith("video/")) {
            return (
                <video
                    src={file.preview}
                    alt={file.name}
                    controls
                />
            );
        } else {
            return <p>Unsupported file type</p>;
        }
    };

    // Dropzone setup
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: ["video/mp4", "video/avi", "video/mkv"], // Accept video files
        // multiple, // Whether to allow multiple files
    });

    return (
        <>
            {
                files.length > 0 ? '' :
                    <div className="d-flex flex-column align-items-center">


                        <div className="spacer"/>
                        <h3 style={{border: 'unset', paddingBottom: '0px'}}>
                            ویدیو آموزشی خود را در اینجا رها کنید
                        </h3>
                        <p>
                            حجم فایل شما باید حداکثر ۱۵ مگابایت باشد.
                        </p>

                        <div{...getRootProps()} className={'image-file-upload-container-v3'}>
                            <input {...getInputProps()} />
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2775_7918)">
                                    <path d="M43.5375 22.59C42.0075 14.8275 35.19 9 27 9C20.4975 9 14.85 12.69 12.0375 18.09C5.265 18.81 0 24.5475 0 31.5C0 38.9475 6.0525 45 13.5 45H42.75C48.96 45 54 39.96 54 33.75C54 27.81 49.3875 22.995 43.5375 22.59ZM31.5 29.25V38.25H22.5V29.25H15.75L26.2125 18.7875C26.6625 18.3375 27.36 18.3375 27.81 18.7875L38.25 29.25H31.5Z" fill="url(#paint0_linear_2775_7918)"/>
                                </g>
                                <defs>
                                    <linearGradient id="paint0_linear_2775_7918" x1="27" y1="9" x2="27" y2="45" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#24C78C"/>
                                        <stop offset="1" stop-color="#2B5747"/>
                                    </linearGradient>
                                    <clipPath id="clip0_2775_7918">
                                        <rect width="54" height="54" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
            }

            {files.length > 0 && (
                <div style={{marginTop: "20px"}}>
                    <ul className="video-file-upload-container-ul">
                        {files.map((file, index) => (
                            <li
                                key={index}
                                className="video-file-container"
                            >
                                <div className="remove-image-btn" onClick={() => {
                                    setFiles([])
                                }}>
                                    <IoClose size={20} color={"#fff"}/>
                                </div>
                                {renderPreview(file)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};

export const ImageFileUploadV2 = ({multiple = false, onChange}) => {
    const [files, setFiles] = useState([]);

    useEffect(() => {
        onChange(files);
    }, [files])
    // When files are dropped, this callback handles them.
    const onDrop = useCallback((acceptedFiles) => {
        // Map through the files and set a preview URL for each image
        if (multiple) {
            setFiles((prevFiles) => [
                ...prevFiles,
                ...acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                ),
            ]);
        } else {
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        }
    }, [multiple]);

    // Remove the file by filtering it out from the state
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Only render image previews
    const renderPreview = (file) => {
        return <img src={file.preview} alt={file.name}/>;
    };

    // Dropzone setup: Accept only image files and allow multiple file upload
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: ['image/*'], // Accept only image files
        multiple, // Whether multiple files are allowed
    });

    return (
        <div style={{width: "100%"}}>
            <div
                {...getRootProps()}
                className={'image-file-upload-container'}
            >
                <input {...getInputProps()} />
                <MdOutlineAddPhotoAlternate size={60} color={"#38AF84"}/>
                {isDragActive ? (
                    <p>drop selected images here</p>
                ) : (
                    <p>
                        Drag and drop an image, or <a href={'#'}>Browse</a> <br/>
                        <span>Max 5MB each (12MB for videos)</span>
                        {/*{multiple ? '' : ' (1 image only)'}.*/}
                    </p>
                )}
            </div>

            {files.length > 0 && (
                <div style={{marginTop: '20px'}}>
                    <ul className={"image-file-upload-container-ul"}>
                        {files.map((file, index) => (
                            <li key={index} style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                                {renderPreview(file)}
                                <IoCloseCircleSharp className="closeBtn" size={30} color={"#d93d3d"} onClick={() => {
                                    removeFile(file.name)
                                }}/>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export const FileUploadV2 = ({multiple = false, onChange}) => {
    const [files, setFiles] = useState([]);

    useEffect(() => {
        onChange(files);
    }, [files])
    // When files are dropped, this callback handles them.
    const onDrop = useCallback((acceptedFiles) => {
        // Map through the files and set a preview URL for each image
        if (multiple) {
            setFiles((prevFiles) => [
                ...prevFiles,
                ...acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                ),
            ]);
        } else {
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        }
    }, [multiple]);

    // Remove the file by filtering it out from the state
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Only render image previews
    const renderPreview = (file) => {
        return <img src={file.preview} alt={file.name}/>;
    };

    // Dropzone setup: Accept only image files and allow multiple file upload
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: "", // Accept only image files
        multiple, // Whether multiple files are allowed
    });

    return (
        <div style={{width: "100%"}}>
            <div
                {...getRootProps()}
                className={'image-file-upload-container'}
            >
                <input {...getInputProps()} />
                <TfiFiles size={60} color={"#38AF84"}/>
                {isDragActive ? (
                    <p>drop selected Files here</p>
                ) : (
                    <p>
                        Drag and drop Files, or <a href={'#'}>Browse</a> <br/>
                        <span>Max 5MB each (12MB for Videos)</span>
                        {/*{multiple ? '' : ' (1 image only)'}.*/}
                    </p>
                )}
            </div>

            {files.length > 0 && (
                <div style={{marginTop: '20px'}}>
                    <ul className={"image-file-upload-container-ul"}>
                        {files.map((file, index) => (
                            <li key={index} style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                                {renderPreview(file)}
                                <IoCloseCircleSharp className="closeBtn" size={30} color={"#d93d3d"} onClick={() => {
                                    removeFile(file.name)
                                }}/>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};


export const FileUploadV3 = ({multiple = false,accept = "", onChange}) => {
    const [files, setFiles] = useState([]);

    useEffect(() => {
        onChange(files);
    }, [files])
    // When files are dropped, this callback handles them.
    const onDrop = useCallback((acceptedFiles) => {
        // Map through the files and set a preview URL for each image
        if (multiple) {
            setFiles((prevFiles) => [
                ...prevFiles,
                ...acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                ),
            ]);
        } else {
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        }
    }, [multiple]);

    // Remove the file by filtering it out from the state
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Only render image previews
    const renderPreview = (file) => {
        return <img src={file.preview} alt={file.name}/>;
    };

    // Dropzone setup: Accept only image files and allow multiple file upload
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: accept, // Accept only image files
        multiple, // Whether multiple files are allowed
    });

    return (
        <div style={{width: "100%", padding: "50px 0px"}} className="d-flex flex-column align-items-center justify-content-center">

            <div{...getRootProps()} className={'image-file-upload-container-v3'}>
                <input {...getInputProps()} />
                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2775_7918)">
                        <path d="M43.5375 22.59C42.0075 14.8275 35.19 9 27 9C20.4975 9 14.85 12.69 12.0375 18.09C5.265 18.81 0 24.5475 0 31.5C0 38.9475 6.0525 45 13.5 45H42.75C48.96 45 54 39.96 54 33.75C54 27.81 49.3875 22.995 43.5375 22.59ZM31.5 29.25V38.25H22.5V29.25H15.75L26.2125 18.7875C26.6625 18.3375 27.36 18.3375 27.81 18.7875L38.25 29.25H31.5Z" fill="url(#paint0_linear_2775_7918)"/>
                    </g>
                    <defs>
                        <linearGradient id="paint0_linear_2775_7918" x1="27" y1="9" x2="27" y2="45" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#24C78C"/>
                            <stop offset="1" stop-color="#2B5747"/>
                        </linearGradient>
                        <clipPath id="clip0_2775_7918">
                            <rect width="54" height="54" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

            {files.length > 0 && (
                <div style={{marginTop: '20px', width: '100%'}}>
                    <ul className={"file-upload-v3-container-ul"}>
                        {files.map((file, index) => (
                            <li key={index} className="file-item-v3">
                                {file.name} <div style={{width: "16px"}}>{getFileIcon(file.name.split(".").pop())} </div>
                                <IoCloseCircleSharp className="closeBtn" size={30} color={"#d93d3d"} onClick={() => {
                                    removeFile(file.name)
                                }}/>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};



export const TicketFileUpload = ({multiple = false,accept = "", onChange}) => {
    const [files, setFiles] = useState([]);

    useEffect(() => {
        onChange(files);
    }, [files])
    // When files are dropped, this callback handles them.
    const onDrop = useCallback((acceptedFiles) => {
        // Map through the files and set a preview URL for each image
        if (multiple) {
            setFiles((prevFiles) => [
                ...prevFiles,
                ...acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                ),
            ]);
        } else {
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        }
    }, [multiple]);

    // Remove the file by filtering it out from the state
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Only render image previews
    const renderPreview = (file) => {
        return <img src={file.preview} alt={file.name}/>;
    };

    // Dropzone setup: Accept only image files and allow multiple file upload
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: accept, // Accept only image files
        multiple, // Whether multiple files are allowed
    });

    return (
        <div className="d-flex flex-column align-items-center justify-content-center">

            {
                files.length === 0 ?
                    <div{...getRootProps()} className={'ticket-file-upload-container'}>
                        <input {...getInputProps()} />
                        <RiUploadCloudLine size={22} color={"#cdcdcd"}/>
                        انتخاب فایل...
                    </div> : ''
            }


            {files.length > 0 && (
                <div style={{marginTop: '20px', width: '100%'}}>
                    <ul className={"file-upload-v3-container-ul"}>
                        {files.map((file, index) => (
                            <li key={index} className="ticket-file-item">
                                <div className={'ticket-file-item-text'}>
                                    {file.name}
                                </div>
                                <div style={{width: "16px"}}>{getFileIcon(file.name.split(".").pop())} </div>
                                <IoCloseCircleSharp className="closeBtn" size={30} color={"#d93d3d"} onClick={() => {
                                    removeFile(file.name)
                                }}/>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};


export const ImageUploadV3 = ({resetUploader, multiple = false,accept = "", onChange}) => {
    const [files, setFiles] = useState([]);

    useEffect(() => {
        onChange(files);
    }, [files])

    useEffect(() => {
        if(resetUploader === true)
            setFiles([])
    }, [resetUploader])

    // When files are dropped, this callback handles them.
    const onDrop = useCallback((acceptedFiles) => {
        // Map through the files and set a preview URL for each image
        if (multiple) {
            setFiles((prevFiles) => [
                ...prevFiles,
                ...acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                ),
            ]);
        } else {
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        }
    }, [multiple]);

    // Remove the file by filtering it out from the state
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Only render image previews
    const renderPreview = (file) => {
        return <img src={file.preview} alt={file.name}/>;
    };

    // Dropzone setup: Accept only image files and allow multiple file upload
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: ['image/*'], // Accept only image files
        multiple, // Whether multiple files are allowed
    });

    return (
        <div style={{width: "100%", padding: "50px 0px"}} className="d-flex flex-column align-items-center justify-content-center">

            {
                files.length === 0 || multiple ?
                    <div{...getRootProps()} className={'image-file-upload-container-v3'}>
                        <input {...getInputProps()} />
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2775_7918)">
                                <path d="M43.5375 22.59C42.0075 14.8275 35.19 9 27 9C20.4975 9 14.85 12.69 12.0375 18.09C5.265 18.81 0 24.5475 0 31.5C0 38.9475 6.0525 45 13.5 45H42.75C48.96 45 54 39.96 54 33.75C54 27.81 49.3875 22.995 43.5375 22.59ZM31.5 29.25V38.25H22.5V29.25H15.75L26.2125 18.7875C26.6625 18.3375 27.36 18.3375 27.81 18.7875L38.25 29.25H31.5Z" fill="url(#paint0_linear_2775_7918)"/>
                            </g>
                            <defs>
                                <linearGradient id="paint0_linear_2775_7918" x1="27" y1="9" x2="27" y2="45" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#24C78C"/>
                                    <stop offset="1" stop-color="#2B5747"/>
                                </linearGradient>
                                <clipPath id="clip0_2775_7918">
                                    <rect width="54" height="54" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div> : ''
            }

            {files.length > 0 && (
                <div style={{marginTop: '20px', width: '100%'}}>
                    <ul className={"file-upload-v3-container-ul"}>
                        {files.map((file, index) => (
                            <li key={index} className="image-item-v3">
                                {renderPreview(file)}
                                <IoCloseCircleSharp className="closeBtn" size={30} color={"#d93d3d"} onClick={() => {
                                    removeFile(file.name)
                                }}/>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ImageFileUploadV2;
